<template>
	<div class="orderDetail">
		<meta name="description" content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"/>
		<title>订单详情-以诺教育</title>
		<headTop></headTop>
		<div class="loading" v-show="loading"><img src="../../assets/loading.gif"/></div>
		
		<div class="payState" v-for="item in list">
			<div class="state" v-show="payment1">
				<p class="stateText">待支付</p>
				<span class="countDown" id="countDown"></span>
				<div class="Immediate"><router-link :to="{name:'PaymentOrder',params:{id:item.order_id}}">立即支付</router-link></div>
			</div>
			<div class="state" v-show="payment2">
				<p class="stateText">待审核</p>
				<!--<span class="countDown">请在20:59:48内支付，逾时订单将自动关闭</span>-->
				<!--<div class="Immediate"><router-link to="/PaymentOrder">立即支付</router-link></div>-->
			</div>
			<div class="state" v-show="payment3">
				<p class="stateText">已付款</p>
				<!--<span class="countDown">请在20:59:48内支付，逾时订单将自动关闭</span>-->
				<div class="Immediate"><router-link :to="{name:'ApplyInvoice',params:{id:item.order_id}}" v-if="zhShenQing">申请发票</router-link></div>
			</div>
			<div class="state" v-show="payment4">
				<p class="stateText">已关闭</p>
				<!--<span class="countDown">请在20:59:48内支付，逾时订单将自动关闭</span>-->
				<!--<div class="Immediate"><router-link to="/PaymentOrder">立即支付</router-link></div>-->
			</div>
			<div class="state" v-show="payment5">
				<p class="stateText">已取消</p>
				<!--<span class="countDown">请在20:59:48内支付，逾时订单将自动关闭</span>-->
				<!--<div class="Immediate"><router-link to="/PaymentOrder">立即支付</router-link></div>-->
			</div>
			<div class="orderCon">订单信息</div>
			<div >
			<div class="payNumber">
				<p class="orderNumber">订单编号：<span>{{item.order_id}}</span></p>
				<p class="orderTime">下单时间：<span>{{item.order_date}}</span></p>
			</div>
			<div class="detailed">
				<div class="contentImg"><img :src="item.img_url"/></div>
				<div class="contentTitle">
					<h2 class="orderTitle">{{item.name}}</h2>
					<p>开班地点：<span>{{item.address}}</span></p>
					<p>开班时间：<span>{{item.classes_begin}}至{{item.classes_end}}</span></p>
				</div>
				<div class="payMoney">
					<p class="actual">实付金额</p>
					<p class="moneyNum">￥{{item.unit_price}}</p>
					<p class="sum">金额明细</p>
				</div>
				<div class="clears"></div>
				<ul class="floatDetail">
					<li  v-if="item.price_type=='市场价'?false:true">市场价<span>￥{{item.market_price}}</span></li>
					<li >{{item.price_type}}<span>￥{{item.payment}}</span></li>
					<li>报名人数<span>×{{item.order_num}}</span></li>
					<li>抵扣奖学金<span>￥{{item.scholarship}}</span></li>
					<li>优惠券<span>￥{{item.coupon_price}}</span></li>
					<li class="BasePrice">学费抵扣<b class="integ">(积分-{{item.integral}})</b><span>￥{{item.tuition}}</span></li>
				</ul>
			</div>
			</div>
			<div class="applicant">
				<p class="peopleInfo">报名人信息</p>
				<ul class="field">
					<li class="fullName">姓名</li>
					<li class="handPhone">手机</li>
					<li class="ident">{{shenfen}}</li>
					<li class="passport" v-if="huzhao==1?false:true">护照号</li>
				</ul>
				<div class="clears"></div>
				<ul class="field2" v-for="item in Applicant">
					<li class="fullName">{{item.name}}</li>
					<li class="handPhone">{{item.mobile}}</li>
					<li class="ident">{{item.identity}}</li>
					<li class="passport" v-if="huzhao==1?false:true">{{item.passport_id}}</li>
				</ul>
				<div class="clears" v-for="item in list"></div>
					<h1 class="contactInfo">联系人信息</h1>
					<p class="contactPeople">姓名<span>{{item.o_name}}</span></p>
					<p class="contactPeople">手机<span>{{item.mobile}}</span></p>
			</div>
		</div>
		<Bottom></Bottom>
	</div>
</template>

<script>
	import headTop from "../headTop/headTop"
    import Bottom from "../Bottom/Bottom"
	export default{
		name:"orderDetail",
		components:{headTop,Bottom},
		data(){
			return{
				list:[],
				payment1:false,
				payment2:false,
				payment3:false,
				payment4:false,
				payment5:false,
				time:'',
				Applicant:[],
				id:this.$route.params.id,
        		zhShenQing:true,
        		loading:true,
        		shenfen:0,
        		huzhao:''
			}
		},
		methods:{

		},
		created(){
			var that=this
			that.loading=true
		/*--------------------------订单详情----------------------------------*/
			that.$ajax({
				method:"post",
				url:"/api/MyOrderDetail",
				params:{"id":that.id}
			}).then(function(data){
				that.loading=false
				that.list=data.data.result
				that.time=data.data.result[0].pending_paytime
				that.Applicant=data.data.result[0].sign_user_info
				that.huzhao=data.data.result[0].sign_user_info[0].identity_type
				if(data.data.result[0].sign_user_info[0].identity_type==0){
					that.shenfen="身份证"
				}else if(data.data.result[0].sign_user_info[0].identity_type==1){
					that.shenfen="护照"
				}else if(data.data.result[0].sign_user_info[0].identity_type==2){
					that.shenfen="台胞证"
				}else{
					that.shenfen="回乡证"
				}
        if(data.data.result[0].invoice == 1){
          that.zhShenQing = true;
        }else{
          that.zhShenQing = false;
        }
				if(data.data.result[0].order_status==1){
					that.payment1=true
				}else if(data.data.result[0].order_status==0){
					that.payment2=true
				}else if(data.data.result[0].order_status==2){
					that.payment3=true
				}else if(data.data.result[0].order_status==4){
					that.payment4=true
				}else if(data.data.result[0].order_status==3){
					that.payment5=true
				}

				function timer(intDiff){
		    window.setInterval(function(){
		    var day=0,
		        hour=0,
		        minute=0,
		        second=0;//时间默认值
		    if(intDiff > 0){
		        day = Math.floor(intDiff / (60 * 60 * 24));
		        hour = Math.floor(intDiff / (60 * 60)) - (day * 24);
		        minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60);
		        second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
		    }
		    if (minute <= 9) minute = '0' + minute;
		    if (second <= 9) second = '0' + second;
		    if(day>0){
		    	$('#countDown').html("请在"+'<s id="h"></s>'+day+'天'+'<s id="h"></s>'+hour+':'+'<s></s>'+minute+':'+'<s></s>'+second+''+"内支付，逾时订单将自动关闭");
		    }else{
		    	$('#countDown').html("请在"+'<s id="h"></s>'+hour+':'+'<s></s>'+minute+':'+'<s></s>'+second+''+"内支付，逾时订单将自动关闭");
		    }
		    intDiff--;
		    }, 1000);
		}
		$(function(){
			timer(that.time)
		})
			}).catch(function(err){
				console.log(err)
			})
		},
		mounted(){
			$(document).on("mousemove",".sum",function(){
				$(".floatDetail").css({"display":"block"})
			})
			$(document).on("mouseleave",".sum",function(){
				$(".floatDetail").css({"display":"none"})
			})
		}

	}
</script>

<style scoped="scoped">
	.orderDetail{width:100%;background:#f4f5f9;}
	.payState{width:960px;margin:0 auto;padding-top:30px;padding-bottom:250px;}
	.state{width:960px;height:90px;background:#fff;margin-bottom:18px;}
	.stateText{float:left;font-size: 24px;line-height:90px;margin:0 20px 0 30px;}
	.countDown{float:left;line-height:90px;color:#ff5050;}
	.Immediate{float:right;width:170px;line-height:90px;text-align: center;font-size: 16px;color:#01b784;font-weight: 900;}
	.orderCon{width:182px;line-height:48px;border-top:3px solid #01b784;margin-top:10px;font-size: 16px;text-align: center;color:#01b784;background:#fff;}
	.payNumber{width:100%;height:80px;background:#fff;font-size: 16px;}
	.orderNumber{float:left;line-height:80px;margin:0 28px;}
	.orderTime{float:left;border-left:1px solid #e6e6e6;padding-left:30px;margin-top:30px;}
	.detailed{width:100%;height:160px;background:#fff;border-top:1px solid #e6e6e6;position:relative;}
	.contentImg img{width:200px;height:100px;margin:30px;background:red;float:left;}
	.contentTitle{width:500px;height:85px;margin-top:38px;border-right:1px solid #e6e6e6;float:left;}
	.contentTitle p{line-height:24px;color:#909090;}
	.orderTitle{font-size: 20px;font-weight: 100;color:#4f4f4f;margin-bottom:10px;}
	.payMoney{width:170px;height:200px;float:right;margin-top:30px;color:#4F4F4F;}
	.actual{margin:12px 0;}
	.moneyNum{font-size: 24px;margin:0 0 12px -4px;}
	.floatDetail{width:280px;min-height:192px;background:#fff;position:absolute;z-index: 5;top:136px;left:766px;color:#4f4f4f;display:none;}
	.floatDetail li{margin:20px 0 0 30px;}
	.floatDetail li span{float:right;margin-right:28px;}
	.BasePrice{padding-bottom:20px;}
	.clears{clear:both;}
	.sum:hover{color:#01b784;}
	.applicant{width:100%;background:#fff;margin:10px auto 30px;height:100%;}
	.peopleInfo{font-size: 18px;padding:27px 30px;}
	.field{width:762px;margin-left:30px;height:40px;background:#f5f5f5;}
	.field2{width:762px;margin-left:30px;border-bottom:1px solid #e6e6e6;height:50px;}
	.field2 li{float:left;line-height:50px;text-align: center;color:#4f4f4f;}
	.field li{float:left;background:#f5f5f5;line-height:40px;text-align: center;color:#909090;}
	.fullName{width:162px;height:1px;}
	.handPhone{width:196px;height:1px;}
	.ident{width:230px;height:1px;}
	.passport{width:174px;height:1px;}
	.contactInfo{margin:45px 0 30px 30px;font-size: 18px;font-weight: 100;}
	.contactPeople{padding:0 0 20px 50px;}
	.contactPeople span{margin-left:20px;}
	a:visited{color:#01b784;}
    a{color:#27cb9a;}
    .loading{width:100%;min-height: 720px;display: flex;display:-ms-flexbox;justify-content: center;align-items: center;background: #fff;padding-bottom:250px;}
</style>



// WEBPACK FOOTER //
// orderDetail.vue?1eea9228